import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableBoolean, nullableNumber, nullableString } from '../utils/wire-value-utils';
import { TestAttemptStatus } from './test-attempt-status.model';

/**
 * A test attempt as `GET /admin/safety-tests/test-attempts` returns it (hub `data-models/test-attempt.ts` plus
 * `testTitle`). Read-only. Times are ISO strings as sent.
 */
export class TestAttempt extends Base {
  testId?: string | null;
  testTitle?: string | null;
  profileId?: string | null;
  organizationId?: string | null;
  status?: TestAttemptStatus | null;
  score?: number | null;
  passed?: boolean | null;
  totalQuestions?: number | null;
  correctAnswers?: number | null;
  startedAt?: string | null;
  completedAt?: string | null;
  timeSpentSeconds?: number | null;
  expiresAt?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.testId = nullableString(source['testId']);
    this.testTitle = nullableString(source['testTitle']);
    this.profileId = nullableString(source['profileId']);
    this.organizationId = nullableString(source['organizationId']);
    this.status = nullableString(source['status']) as TestAttemptStatus | null | undefined;
    this.score = nullableNumber(source['score']);
    this.passed = nullableBoolean(source['passed']);
    this.totalQuestions = nullableNumber(source['totalQuestions']);
    this.correctAnswers = nullableNumber(source['correctAnswers']);
    this.startedAt = nullableString(source['startedAt']);
    this.completedAt = nullableString(source['completedAt']);
    this.timeSpentSeconds = nullableNumber(source['timeSpentSeconds']);
    this.expiresAt = nullableString(source['expiresAt']);
  }
}
